import React, { useState } from 'react';
import { CoreMeitnerUserConfiguration, meitnerMobilePhoneNumberExportTypeOptions } from '../../../../../../models/CoreMeitnerModels';
import CheckboxListItem from '../../../../../misc/CheckboxListItem';
import NullableIntInput from '../../../../../misc/NullableIntInput';
import EnumInput from '../../../../../misc/EnumInput';

import { useTranslation } from 'react-i18next';
import { Card, CardHeader, Button, Collapse, CardBody } from 'reactstrap'


interface MeitnerUserProps {
    user: CoreMeitnerUserConfiguration
    disabled: boolean
    name: string
    updateValue: (x: CoreMeitnerUserConfiguration) => void
    displayName: string
    validation: string[],
    isGuardianConfig?: boolean
}


const MeitnerUser = (props: MeitnerUserProps) => {
    const { t } = useTranslation(['configuration']);
    const [isOpen, setIsOpen] = useState<boolean>(true);

    const updateConfig = (change: Partial<CoreMeitnerUserConfiguration>) =>
        props.updateValue({ ...props.user, ...change });

    return (
        <Card className="mb-3">
            <CardHeader tag="h5">
                <Button outline color="secondary" style={{ width: '30px', float: 'right', lineHeight: '0.8', padding: '0.5rem' }} onClick={() => setIsOpen(!isOpen)}>{isOpen ? '-' : '+'}</Button>
                {props.displayName}
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>

                    <CheckboxListItem
                        text={t('meitnerExportConfiguration.sendAddress', { ns: 'configuration' })}
                        id="sendAddress"
                        name="sendAddress"
                        value={props.user.sendAddress}
                        disabled={props.disabled}
                        onChange={(e) => updateConfig({ sendAddress: e.target.checked })}
                    />

                    <CheckboxListItem
                        text={t('meitnerExportConfiguration.sendEmailAddress', { ns: 'configuration' })}
                        id="sendEmailAddress"
                        name="sendEmailAddress"
                        value={props.user.sendEmailAddress}
                        disabled={props.disabled}
                        onChange={(e) => updateConfig({ sendEmailAddress: e.target.checked })}
                    />
                {!props.isGuardianConfig ? (
                    <CheckboxListItem
                        text={t('meitnerExportConfiguration.sendTelephoneNumber', { ns: 'configuration' })}
                        id="sendMobileNumber"
                        name="sendMobileNumber"
                        value={props.user.sendTelephoneNumber}
                        disabled={props.disabled}
                        onChange={(e) => updateConfig({ sendTelephoneNumber: e.target.checked })}
                    /> )
                    :
                    (
                    <div className='mt-2'>
                    <EnumInput
                        title={t('meitnerExportConfiguration.mobilePhoneNumberExportType.title', { ns: 'configuration' })}
                        titleSmall = {true}
                        value={props.user.sendMobilePhoneNumber}
                        options={meitnerMobilePhoneNumberExportTypeOptions.map(x => ({
                            value: x,
                            text: t(`meitnerExportConfiguration.mobilePhoneNumberExportType.options.${x}`, { ns: 'configuration' }),
                        }))}
                        onChange={(name, value) => updateConfig({ [name]: value })}
                        disabled={props.disabled}
                        name='sendMobilePhoneNumber'
                    />
                     </div>
                     )
                    }
                    
                    <NullableIntInput
                        title={t('meitnerExportConfiguration.gracePeriod.title', { ns: 'configuration' })}
                        value={props.user.gracePeriod}
                        name="gracePeriod"
                        disabled={props.disabled}
                        updateValue={(name, value) => updateConfig({ [name]: value })}
                        defaultValue={0}
                        invalid={props.validation.indexOf(`${props.name}.gracePeriod`) !== -1 }
                        invalidFeedback={t('meitnerExportConfiguration.gracePeriod.invalidFeedback', { ns: 'configuration' })}
                    />

                </CardBody>
            </Collapse>
        </Card>
    );
};

export default MeitnerUser;
